import { c as _c } from "react/compiler-runtime";
// /profile без раздела. Старая страница-вкладки жила на /profile?tab=… —
// ссылки из писем, уведомлений и закладок переводим на новые разделы.
import { Navigate, useSearchParams } from "react-router";
const TAB_TO_PATH: Record<string, string> = {
  profile: "/profile/personal",
  orders: "/profile/orders",
  balance: "/profile/balance",
  billing: "/profile/payments",
  addresses: "/profile/addresses",
  payments: "/profile/payments",
  sessions: "/profile/devices"
};
export function ProfileIndexRedirect() {
  const $ = _c(6);
  const [params] = useSearchParams();
  let t0;
  if ($[0] !== params) {
    t0 = params.get("tab");
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const tab = t0;
  if (tab === "chats") {
    const conversation = params.get("conversation");
    const t1 = conversation ? `/chats?conversation=${encodeURIComponent(conversation)}` : "/chats";
    let t2;
    if ($[2] !== t1) {
      t2 = <Navigate to={t1} replace={true} />;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  const t1 = tab && TAB_TO_PATH[tab] || "/profile/orders";
  let t2;
  if ($[4] !== t1) {
    t2 = <Navigate to={t1} replace={true} />;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}